import Box from "@memorang/ui/components/Box";
import EmptyView from "@memorang/ui/components/EmptyView";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { useRouter } from "expo-router";
import ComingSoonSvg from "../../../../assets/coming-soon.svg";

const DetailArticleSupplementalyView = () => {
	const router = useRouter();
	return (
		<ScrollContainer>
			<Box padding={16}>
				<EmptyView
					title="Coming Soon"
					subtitle="What would you like to see? Leave Feedback"
					image={ComingSoonSvg}
					cta="Leave Feedback"
					handleAction={() =>
						router.push({
							pathname: "/feedback",
							params: {
								isComingSoon: "true",
								view: "article-supplementaly",
							},
						})
					}
				/>
			</Box>
		</ScrollContainer>
	);
};

export default DetailArticleSupplementalyView;
